var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".logintop{background-image:url(" + escape(require("../../assets/img/login.jpg")) + ");background-image:linear-gradient(108deg,#025d91 17.3%,#009cde 77.6%);background-size:cover;color:#fff!important;height:10vh}.form-help span{cursor:pointer}.globe{color:hsla(0,0%,100%,.5)}.logo img{height:5vh}.main-login{height:80vh}.profile a{color:#000}", ""]);

// exports
